const _ = require('lib/underscore')
const Marionette = require('lib/marionette')

const LabelView = Marionette.View.extend({

    displayName: 'LabelView',

    tagName: 'label',

    className() {
        return this.options.className
    },

    template: _.template('{{ data.label }}'),

    templateContext() {
        return {
            label: this.options.label,
        }
    },

    attributes() {
        return {
            for: this.options.for,
        }
    },

})

module.exports = LabelView
